import classNames from 'classnames'
import { ReactNode } from 'react'

export type FormPanelComponentProps = {
  title: ReactNode
  subtitle?: string
  footnote?: string
  cols?: 1 | 2 | 3 | 4 | 5 | 6
  learnMore?: ReactNode
  children: ReactNode
}

const colSpanClass: Record<number, string> = {
  1: `col-span-1`,
  2: `col-span-2`,
  3: `col-span-3`,
  4: `col-span-4`,
  5: `col-span-5`,
  6: `col-span-6`,
}

export function FormPanelComponent({
  title,
  subtitle,
  footnote,
  cols = 1,
  learnMore,
  children,
}: FormPanelComponentProps) {
  return (
    <div
      className={classNames(
        colSpanClass[cols],
        `flex flex-col gap-y-6 rounded-lg border border-default pb-6 shadow-elevation-2`,
      )}
    >
      <div className="rounded-t-lg border-b border-b-default bg-surface-subtle px-4 py-[15px]">
        <div className="flex items-center justify-between">
          <span className="text-heading-xs capitalize text-strong">{title}</span>
          {learnMore}
        </div>
      </div>
      <div className="px-4">
        {subtitle && <span className="mb-6 text-body-sm text-strong">{subtitle}</span>}
        <div className={classNames(subtitle && `mt-4`)}>{children}</div>
        {footnote && <div className="mt-4 px-4 text-body-xs text-minimal">{footnote}</div>}
      </div>
    </div>
  )
}
